import AppUtils from "../Utils/AppUtils";
import useAPIs from "./useAPIs";

export const orderSummaryModal = {
  distributor_id: sessionStorage.getItem("dist_id"),
  delivery_mode_id: 3,
  warehouse: null,
  address: {
    billing_same_as_shipping: 1,
    shipping: {
      id: null,
      address_line1: "",
      address_line2: "",
      is_billing_address: 0,
      is_shipping_address: 1,
      postcode_id: "",
      city_id: "",
      district_id: "",
      state_id: "",
      country_id: "",
      postalcode: "",
      postalname: "",
      city: "",
      district: "",
      state: "",
      country: "",
      contact_no: "",
    },
    billing: {
      id: null,
      address_line1: "",
      address_line2: "",
      is_billing_address: 1,
      is_shipping_address: 0,
      postcode_id: "",
      city_id: "",
      district_id: "",
      state_id: "",
      country_id: "",
      postalcode: "",
      postalname: "",
      city: "",
      district: "",
      state: "",
      country: "",
      contact_no: "",
    },
  },
  order_items: [],
  is_faster_delivery: 0,
  otp_verification_status: 0,
  is_voucher_applied: 0,
  voucher: [],
};

const useHome = () => {
  const { postData, getData, postFormData } = useAPIs();

  const fetchEligStatus = (payload, onSuccess, onError) => {
    if (!payload.distributor_id) {
      AppUtils.showProcessingDialog(
        "Oops! There seems to be missing data. Please reload the app using the link gave by the distributor."
      );
      return;
    }
    postData(
      "/private/store/order/new/eligstatus",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchLocationsFromPincode = (pincode, onSuccess, onError) => {
    getData(
      `/private/store/location/list/${pincode}`,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchProductsFromPincode = (pincode, onSuccess, onError) => {
    let city_id = "";
    let district_id = "";
    let state_id = "";
    let country_id = "";
    let product_category = "";
    let pv = "";
    let search_key = "";
    getData(
      `/private/store/products?postcode_id=${pincode}&distributor_id=${sessionStorage.getItem("dist_id")}&city_id=&district_id=&state_id=&country_id=&product_category=&pv=&search_key=`,
      (data) => {
        onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const postOrderSummary = (payload, onSuccess, onError) => {
    if (!payload.distributor_id) {
      AppUtils.showProcessingDialog(
        "Oops! There seems to be missing data. Please reload the app using the link gave by the distributor."
      );
      return;
    }
    postData(
      "/private/store/order-summary",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const sendOTP = (payload, onSuccess, onError) => {
    postData(
      "/auth/send-otp-to-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const postVerifyOTP = (payload, onSuccess, onError) => {
    postData(
      "/auth/verify-customer-phone-otp",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const postVerifyWithoutOTP = (payload, onSuccess, onError) => {
    postData(
      "/private/verify-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const signUpCustomer = (payload, onSuccess, onError) => {
    if (!payload.distributor_id) {
      AppUtils.showProcessingDialog(
        "Oops! There seems to be missing data. Please reload the app using the link gave by the distributor."
      );
      return;
    }
    postData(
      "/private/customer-sign-up",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchCustomerDetails = (payload, onSuccess, onError) => {
    postData(
      "/private/fetch-customer-details",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const placeOrder = (payload, onSuccess, onError) => {
    if (!payload.distributor_id) {
      AppUtils.showProcessingDialog(
        "Oops! There seems to be missing data. Please reload the app using the link gave by the distributor."
      );
      return;
    }
    postData(
      "/private/store/place-order",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const orderPayment = (payload, onSuccess, onError) => {
    postFormData(
      "/private/order-payment",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const logCampaignClick = (payload, onSuccess, onError) => {
    postData(
      "/notif/product-expiry-sms-clicked",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
        console.log("logCampaignClick", data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const phoneVerification = (payload, onSuccess, onError) => {
    if (!payload.phone) {
      AppUtils.showProcessingDialog(
        "Oops! There seems to be missing data. Please reload the app using the link gave by the distributor."
      );
      return;
    }
    postData(
      "/private/phone-verify",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const reVerifyPhoneNumber = (payload, onSuccess, onError) => {
    postData(
      "/auth/reverify-customer-phone",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };

  const verifyGstNumber = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/gst-number-validation",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchCustomerVouchers = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/fetch-customer-vouchers",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const fetchCustomerVoucherProducts = (payload, onSuccess, onError) => {
    postData(
      "/sales/v1/fetch-customer-vouchers-products",
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
      }
    );
  };
  const uploadPaymentProof = (payload, onSuccess, onError) => {
  postFormData(
    "/private/store/payu-success",
    payload,
    (data) => {
      onSuccess && onSuccess(data);
    },
    (error) => {
      onError && onError(error);
    }
  );
};
  return {
    fetchEligStatus,
    fetchLocationsFromPincode,
    fetchProductsFromPincode,
    postOrderSummary,
    sendOTP,
    postVerifyOTP,
    signUpCustomer,
    fetchCustomerDetails,
    placeOrder,
    orderPayment,
    logCampaignClick,
    phoneVerification,
    postVerifyWithoutOTP,
    reVerifyPhoneNumber,
    verifyGstNumber,
    fetchCustomerVouchers,
    fetchCustomerVoucherProducts,
    uploadPaymentProof
  };
};

export default useHome;